import { Skeleton } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import WidgetCard from '../common/WidgetCard';
import PlantingGroupStageChart from './PlantingGroupStageChart';
import PlantingGroupStageChartSkeleton from './Skeleton';

import useNotifyError from 'hooks/useNotifyError';
import usePlantingGroupStagesQuery from 'screens/season-overview/hooks/usePlantingGroupStagesQuery';

import type { SeasonOverviewCommonWidgetFilters } from 'screens/season-overview/types';

const PlantingGroupStageWidget = ({
  country,
  seasonTypeId,
}: SeasonOverviewCommonWidgetFilters) => {
  const { t } = useTranslation();

  const params = useMemo(
    () => ({ params: { country, seasonTypeId } }),
    [seasonTypeId, country],
  );
  const {
    data: plantingGroupCount,
    isLoading,
    error,
  } = usePlantingGroupStagesQuery(params);

  useNotifyError({
    error,
    msg: 'Could not fetch Planting group stages, Please try again.',
  });

  if (isLoading)
    return (
      <WidgetCard
        header={<Skeleton.Input active />}
        className="planting-group-stages"
      >
        <PlantingGroupStageChartSkeleton />
      </WidgetCard>
    );

  return (
    <WidgetCard
      header={t('seasonOverview.widgets.plantingGroupStages.header')}
      className="planting-group-stages"
    >
      <PlantingGroupStageChart {...plantingGroupCount!} />
    </WidgetCard>
  );
};

export default PlantingGroupStageWidget;
